import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider.jsx';
import App from './App.jsx';

// Same-origin by default: server.mjs proxies /api to the backend, so the browser only
// ever talks to one host. No CORS, no API URL baked into the bundle, and the JWT never
// crosses a second domain. VITE_API_URL exists only for pointing a local dev server at
// a deployed backend.
const API_BASE = import.meta.env.VITE_API_URL || '/api';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider baseUrl={API_BASE}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
